import * as ActionTypes from './ActionTypes'
import { apiGetConfiguration, apiGetGlobalConfiguration } from './Api'

// THUNK
// get configuration
export function getConfiguration(org, env, scope, time) {
  return (dispatch) => {
    apiGetConfiguration(org, env, scope, time)
      .then((response) => {
        dispatch({
          type: ActionTypes.VN_SET_CONFIGURATION,
          configuration: response.data,
        })
      })
      .catch((error) => {})
  }
}

export function getGlobalConfiguration(env, scope, time) {
  return (dispatch) => {
    apiGetGlobalConfiguration(env, scope, time)
      .then((response) => {
        dispatch({
          type: ActionTypes.VN_SET_GLOBAL_CONFIGURATION,
          globalConfiguration: response.data,
        })
      })
      .catch((error) => {})
  }
}
